import { ArrayUtil, ExternalLink } from "@mcleod/core";
import { Component } from "@mcleod/components";
import { PageHeaderProvider } from "@mcleod/common";
import { RapidAlertFeed } from "@mcleod/dispatch";
import { ELearningPortalHomePageLink } from "./ELearningPortalHomePageLink";
import { HelpjuiceLink } from "./HelpjuiceLink";
import { IdeasPortalLink } from "./IdeasPortalLink";

export class LMEPageHeaderProvider extends PageHeaderProvider {
    private static cachedExternalLinks: ExternalLink[];

    /**
     * Returns an array containing components that should be displayed to the user in //web.
     */
    public async getAppSpecificComponents(): Promise<Component[]> {
            return [
                await RapidAlertFeed.createForPageHeader()
            ].filter(item => item != null);
    }

    public override shouldDisplayHelpLinks(): boolean {
        return true;
    }

    public override getAddlExternalLinks(): ExternalLink[] {
        if (ArrayUtil.isEmptyArray(LMEPageHeaderProvider.cachedExternalLinks) === true) {
            LMEPageHeaderProvider.cachedExternalLinks = [ new IdeasPortalLink(), new HelpjuiceLink() ];
        }
        const result: ExternalLink[] = [
            // We don't cache the eLearning Portal link because it includes a key value that includes a timestamp
            new ELearningPortalHomePageLink(),
            ...LMEPageHeaderProvider.cachedExternalLinks
        ];
        return result.filter(link => this.isLinkLicensed(link) === true);
    }

    /**
     * Determines whether the specified link is licensed.  Links that don't require a license are always
     * considered licensed.
     *
     * Licensing isn't known until the user has logged in, so this can't be evaluated when the links are
     * constructed and cached.  getAddlExternalLinks() is called again on every layout change.
     */
    private isLinkLicensed(link: ExternalLink): boolean {
        if (link instanceof HelpjuiceLink) {
            return HelpjuiceLink.isLicensed();
        }
        return true;
    }
}
